<script>import { isHTMLElement } from "../../internal/index.js";
import { getCtx, getState } from "../command.js";
const { ids } = getCtx();
const state = getState();
export let el = void 0;
export let asChild = false;
function sizerAction(node) {
  let animationFrame;
  const listEl = node.closest("[data-cmdk-list]");
  if (!isHTMLElement(listEl)) {
    return;
  }
  const observer = new ResizeObserver(() => {
    animationFrame = requestAnimationFrame(() => {
      const height = node.offsetHeight;
      listEl.style.setProperty("--cmdk-list-height", height.toFixed(1) + "px");
    });
  });
  observer.observe(node);
  return {
    destroy() {
      cancelAnimationFrame(animationFrame);
      observer.unobserve(node);
    }
  };
}
const listAttrs = {
  "data-cmdk-list": "",
  role: "listbox",
  "aria-label": "Suggestions",
  id: ids.list,
  "aria-labelledby": ids.input
};
const sizerAttrs = {
  "data-cmdk-list-sizer": ""
};
const list = {
  attrs: listAttrs
};
const sizer = {
  attrs: sizerAttrs,
  action: sizerAction
};
</script>

{#if asChild}
	{#key $state.search === ''}
		<slot {list} {sizer} />
	{/key}
{:else}
	<div {...listAttrs} bind:this={el} {...$$restProps}>
		<div {...sizerAttrs} use:sizerAction>
			{#key $state.search === ''}
				<slot />
			{/key}
		</div>
	</div>
{/if}
